import { HALApiService } from './../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const helpArticlesService = new CachedService(entities.Orderadmin_Help_Entity_Article, '/help/article', HALApiService, createItemsData)
